import { RenameOrganizationDialog } from '@/features/Organizations/components/RenameOrganizationDialog'
import { useCanRenameOrganization } from '@/features/Organizations/hooks/useCanRenameOrganization'
import { Icon, IconButton } from '@chakra-ui/react'
import { Pencil } from 'lucide-react'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'

type Props = {
  orgId: string
  currentName: string
}

export function RenameOrganizationButton({
  orgId,
  currentName,
}: Readonly<Props>) {
  const { t } = useTranslation('features', { useSuspense: false })
  const canRename = useCanRenameOrganization()
  const [isOpen, setIsOpen] = useState(false)

  if (!canRename) {
    return null
  }

  return (
    <>
      <IconButton
        aria-label={String(t('orgDetails.rename.button'))}
        size="xs"
        variant="ghost"
        onClick={() => setIsOpen(true)}
      >
        <Icon as={Pencil} />
      </IconButton>
      {isOpen ? (
        <RenameOrganizationDialog
          orgId={orgId}
          currentName={currentName}
          onClose={() => setIsOpen(false)}
        />
      ) : null}
    </>
  )
}
